/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnforcementStateEnum = 'NORMAL' | 'GRACE' | 'SUSPENDED' | 'TERMINATED' | 'WARNING' | 'DEGRADED';

export const EnforcementStateEnum = {

    NORMAL: 'NORMAL' as EnforcementStateEnum,

    GRACE: 'GRACE' as EnforcementStateEnum,

    SUSPENDED: 'SUSPENDED' as EnforcementStateEnum,

    TERMINATED: 'TERMINATED' as EnforcementStateEnum,

    WARNING: 'WARNING' as EnforcementStateEnum,

    DEGRADED: 'DEGRADED' as EnforcementStateEnum
};

